import model from "@/mixins/model";

export default  {
    mixins: [model],
    form: true,
    model() {
        return {
            old_password: null,
            password: null
        }
    },
    methods: {
        submit(e) {
            e.preventDefault();

            // console.log('asdasd');

            return this.dispatch( (resolve, reject) => {

                console.log('asdasd');

                this.$http.request({url:'agent/change-password',method:'patch',data:this.model})
                    .then(resolve).catch(reject);

            }).catch(() => {});


        }
    }
}